module.exports = __webpack_public_path__ + "img/tuijianchapin.cbb8bcf9.png";